<div class="container product-listing-page">
    <div class="row g-0 gx-lg-0 breadcrumb-wrapper">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      </div>
  
    </div>
    <div class="row filter-wrapper g-0">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mobile-response">
  
        <div class="row g-0">
          <!--Awadhesh filter left-->
          <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 d-lg-block mobile-view-filter mt-2"
          style="border-right: 1px solid #CDCED5;" [ngClass]="{'show-filters': isFilterOpen}">
          
            <app-tataokfilter></app-tataokfilter>
             
          </div>
          <!--sort-mobile-view-->
          <!--Awadhesh list right-->
          <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
            <div class="d-flex align-items-center">
              <!--tablet filter text-->
              <div class="md-filter d-none d-md-flex d-lg-none">
                Filter <span>11</span>
                <img [src]="environment1 + 'images/new-images/dropdown.svg'" alt="dropdown" loading="lazy">
              </div>
              <div class="filters ps-lg-3 p-0" >
                <h1 > {{TotalCount}} Vehicles found</h1> 
              </div>
              <div class="ms-auto short-by ps-3 pe-3 position-relative d-none d-md-flex">
                Sort by
  
                <div class="sort-filter ps-4 position-relative active">
                  <span class="">Price : </span>
                  <select class="form-select" (change)="onFilterChange($event,'')" [(ngModel)]="sortingType">
                    <option [value]="item" *ngFor="let item of sortList">{{item}}</option>
                  </select>
                </div>
              </div>
  
            </div>
            <div class="item-wrapper" style="border-top: 1px solid #CDCED5;;">
              <!--filter list-->
              <span class="d-flex" style="flex-wrap: wrap;">
                <div class="filter-list d-md-block" *ngFor="let item of filterShowList">
                  <div class="filter-item">
                    <span *ngIf="item.event != 'OSP'">
                      {{item.event}}
                    </span>
                    <span *ngIf="item.event != 'OSP'" class="close" (click)="clickToremoveFilter(item)"></span>
                  </div>
                </div>
              </span>
              <!--product list-->
              <div class="productlist mt-3">
                <div class="row">
                    <ng-container *ngIf="ListingData?.length == 0 && !productLoaded ;else productTemplate">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                          *ngFor="let item of skeletonService.generateFake(6);let i = index;">
                          <div class="poduct-item">
                            <div class="img-wrapper" style="display: block;z-index: 0;">
                              <ngx-skeleton height="230px"></ngx-skeleton>
                            </div>
                            <div class="cv-name text-ellipsis">
                              <ngx-skeleton height="19px"></ngx-skeleton>
                            </div>
                            <div class="price">
                              <ngx-skeleton height="19px"></ngx-skeleton>
                            </div>
                            <div class="rating">
                              <ngx-skeleton height="19px"></ngx-skeleton>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #productTemplate>
                        <ng-container *ngIf="ListingData?.length !== 0 && productLoaded">
                    <div class="col-lg-4 col-md-12 col-sm-12 carddiv" *ngFor="let element of ListingData">
                        <div class="card">
                            <img (click)="redirect(element.id)" [src]="getiscover(element?.vehicle_documents)" class="card-img-top mainimg" alt="Vehicle Image">
                            <div class="d-flex  align-items-center tagf">
                                <span class="badge bg-primary"><img class="eye" [src]='environment1 + "assets/images/eye.png"' alt=""> {{element.view_count}} Views </span>
                                <div class="like ms-auto d-none">
                                  <button style="width: 24px; height: 24px; border: none;background-color: transparent;">
                                    <span >
                                      <img style="width: 24px; height: 24px;" [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                                    </span>
                                  </button>
                                </div>
                              </div>
                              <div *ngIf="element.vehicle_certificate_type == 'Certified'">
                                <img class="tataoklogobottom" [src]='environment1 + "assets/images/tata-ok.png"' alt="">
                                <span class="text-white tataoklogobottomspan">Refurbished</span>
                              </div>
                            <div class="card-body">
                              <div class="card-title text-ellipsis">
                                <a  [title]="element?.model">{{element.model}}</a></div>
                                <div class="card-data">
                                <div class="d-flex col-12 text-left d1 aligndiv ">
                                  <p class="col-4">State</p>
                                  <p class="col-4">District</p>
                                    <p class="col-4">Fuel Type</p>
                                </div>
                                <div class="d-flex col-12 d2 text-left aligndiv d3">
                                  <p class="col-4 district pe-1">{{element?.state}}</p>
                                  <p class="col-4 district">{{element?.district ? (element?.district  | titlecase) : ''}}</p>
                                  <p class="col-4">{{element.fuel_type}}</p>
                                </div>
                                <div class="d-flex col-12  text-left d1 aligndiv mt-2">
                                    <p class="col-4">KMs</p>
                                    <p class="col-4">Owner</p>
                                    <p class="col-4">Year</p>

                                </div>
                               
                                <div class="d-flex col-12 d2 text-left aligndiv">
                                  <p class="col-4">{{element.odometer ? (element.odometer |  number:'1.0-0') : ''}}</p>
                                  <p class="col-4">{{getFirstPartOfOwners(element.no_of_owners)}}</p>
                                  <p class="col-4">{{element.year_of_manufacture}}</p>

                                </div>
                              </div>
                                <div class="d-flex col-12 text-left card-dataprice ">
                                  <p class="price" *ngIf="element.dealer_suggestive_price != null">
                                    {{ 
                                      element.dealer_suggestive_price > 999 
                                        ? (element.dealer_suggestive_price | currency: 'INR': 'symbol': '4.0-0') 
                                        : (element.dealer_suggestive_price | currency: 'INR': 'symbol': '1.0-0') 
                                    }}
                                  </p>
                                  <span class="warranty"  *ngIf="element.engine_warranty === 'Yes'">Warranty Available</span>

                                  <div *ngIf="element.dealer_suggestive_price == null" style="margin-top: 10px;">
                                   <span style="color:#0A0A5F;">Please contact to dealer</span>
                                  </div>
                                </div>
                                <div class="col-12 btngroup">
                                <button  class="btn col-6 btn-outline-primary btn-grad-outline-primary btn-brand  " (click)="redirect(element.id)">View Details</button>
                                <button id="otpVerification"  class="btn col-6 btn-primary  btn-grad-primary btn-brand " data-bs-toggle="modal"  [attr.data-bs-target]="isUserLoggedIn ? '#exampleModal' : '#loginDealer'" (click)="contactDealer(element.id)">Submit Enquiry</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  </ng-container>
                </ng-template>
                    <ng-container *ngIf="ListingData?.length == 0 && productLoaded ">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states">
                          <img [src]='environment1 + "assets/images/no_product_found.svg"' loading="lazy">
                          <h3>
                            No product found
                          </h3>
                          <div class="desc">
                            The product you were looking for couldn’t be found. Explore all <br />
                            products to see more commercial vehicles.
                          </div>
                          <div class="mt-4">
                            <button class="btn btn-primary btn-grad-primary btn-brand ps-4 pe-4"
                            data-toggle="tooltip" data-placement="top"  title="Click here to Explore all products" (click)="exploreProduct()"
                             >Explore all products</button>
                          </div>
                        </div>
                      </ng-container>
                </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </div>
</div>
  <div class="sticky-filter d-flex gap-3 d-lg-none mobile-z-index" *ngIf="isBottomhide" style="z-index: 1000;">
    <a href="javascript:void(0)" class="view-more" (click)="openSort()">
      <img [src]="environment1 + 'images/new-images/sort.svg'" alt="sort" loading="lazy">
      SORT</a>
    <a href="javascript:void(0)" class="view-more" (click)="toggleFilters()"><img [src]="environment1 + 'images/new-images/filter.svg'" alt="filter" loading="lazy">
      Filters</a>
  </div>

  <!--Sort modal in mobile view-->
  
<div class="modal sort-mobile-view" id="sortModal" tabindex="-1" aria-labelledby="sortModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="sortModalLabel">Sort</div>
        <a href="javascript:void(0)" role="button" data-bs-dismiss="modal" (click)="closeSort()">CLOSE</a>
      </div>
      <div class="modal-body">
        <ul>
          <li><a  (click)="onFilterChange('Select','')">Select</a></li>
          <li><a  (click)="onFilterChange('Low To High','')">Low to High</a></li>
          <li><a (click)="onFilterChange('High To Low','')">High to Low</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modaldiv">
      <div class="modal-header" style="border-bottom: none !important;">
        <h1 *ngIf="!disableForm" class="modal-title fs-5" id="exampleModalLabel">Personal Details</h1>
        <button type="button" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-secondary" style="height: 100% !important;margin-top: 0px;padding-top: 0px;">
        <div *ngIf="!disableForm">
        <form [formGroup]="userFormplp">
        <div class="col-12">
          <label>Name </label>
              <input [ngClass]="{
                'disabled': userData?.first_name || userData?.last_name
              }" type="text" class="form-control h-48" formControlName="name" placeholder="Enter Name"
                 (keydown)="notAllowSpace($event)" />
                 <div *ngIf="userFormplp.controls['name'].invalid && (userFormplp.controls['name'].dirty || userFormplp.controls['name'].touched)">
                  <div *ngIf="userFormplp.controls['name'].errors?.required" class="text-danger">Name is required.</div>
                </div>
        </div>
        <div class="col-12 mt-3">
          <label>Contact Info</label>
          <div class="form-input">
            <div class="country-code">
              <div class="nation-flag">
                <img alt="Nation Flag" [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy"/>
              </div>
              +91
            </div>
            <input formControlName="contact" type="tel"  class="mobile_no"
              maxlength="10" placeholder="Mobile Number" numbersOnly [ngClass]="{
                'disabled': userData?.mobile_number
              }" />
             
          </div>
          <div *ngIf="userFormplp.controls['contact'].invalid && (userFormplp.controls['contact'].dirty || userFormplp.controls['contact'].touched)">
            <div *ngIf="userFormplp.controls['contact'].errors?.required" class="text-danger">Contact number is required.</div>
            <div *ngIf="userFormplp.controls['contact'].errors?.pattern" class="text-danger">Contact number must be 10 digits long.</div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <label>Do you need financing ? </label> 
          <div class="mt-3">
            <input id="subscription" type="radio" formControlName="consent" value="yes"> Yes
            <input id="subscription" class="ps-2" type="radio" formControlName="consent" value="no"> No
          </div>
          <div *ngIf="userFormplp.controls['consent'].invalid && (userFormplp.controls['consent'].dirty || userFormplp.controls['consent'].touched)">
            <div *ngIf="userFormplp.controls['consent'].errors?.required" class="text-danger">consent choice is required.</div>
          </div>
          <div class="form-check mt-2">
            <input class="form-check-input consent-box" type="checkbox" value="" id="defaultCheck1" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)">
            <label class="form-check-label" for="defaultCheck1">
              Consent to allow TATA Motors to contact you
            </label>
          </div>
        </div>
        <div class="col-12 mt-3">
       <button class="btn col-12 btn-primary  btn-grad-primary btn-brand h-48" [disabled]="userFormplp.invalid" [ngClass]="{'disabled': !checkBoxcheked}" (click)="onSubmit()">Submit</button>
        </div>
      </form>
    </div>
      <div *ngIf="disableForm">
        <div *ngIf="errorMessage?.success">
          <div class="d-flex justify-content-center">
            <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/success.svg"'alt="">
          </div>
          <h2 class="text-center text-dark fw-bold mb-4">Congratulations!</h2>
          <h3 class="text-center text-secondary fw-bold mb-4" style="font-size: larger;">Dealer from TATA Motors will get in touch  with you soon</h3>
          <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Back to Page</button>
        </div>
        <div *ngIf="!errorMessage?.success">
          <div class="d-flex justify-content-center">
            <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/rejected.svg"' alt="">
          </div>
          <h4 class="text-center text-dark fw-bold mb-4">There was some error while submitting.<br>Please try after some time.</h4>
          <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Retry</button>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="loginDealer"
  tabindex="-1"
  aria-labelledby="loginDealerLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modaldiv">
      <div class="modal-header" style="border-bottom: none !important">
        <h1
          *ngIf="!disableForm"
          class="modal-title fs-5"
          id="loginDealerLabel"
        >
          Login With OTP
        </h1>
        <button
          type="button"
          id="closeBtn1"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          aria-hidden="true"
        ></button>
      </div>
      <div
        class="modal-body text-secondary"
        style="height: 100% !important; margin-top: 0px; padding-top: 0px"
      >
        <div *ngIf="!disableForm">
          <form [formGroup]="userLoginForm">
            <div class="col-12 mt-3">
              <label for="mobileNumber">Contact Info</label>
              <div class="form-input">
                <div class="country-code">
                  <div class="nation-flag">
                    <img
                      alt="Nation Flag"
                      [src]='environment1 + "assets/images/ind-flag.svg"'
                      class="img-fluid"
                      loading="lazy"
                    />
                  </div>
                  +91
                </div>
                <input
                  id="mobileNumber"
                  formControlName="mobile_number"
                  type="tel"
                  class="mobile_no"
                  maxlength="10"
                  placeholder="Mobile Number"
                  numbersOnly
                  (keypress)="onlyNumberKey($event)"
                  [ngClass]="{
                    'disabled': userData?.mobile_number
                  }"
                />
              </div>
              <div
                *ngIf="userLoginForm.controls['mobile_number'].invalid && (userLoginForm.controls['mobile_number'].dirty || userLoginForm.controls['mobile_number'].touched)"
              >
                <div
                  *ngIf="userLoginForm.controls['mobile_number'].errors?.required"
                  class="text-danger"
                >
                  Contact number is required.
                </div>
                <div
                  *ngIf="userLoginForm.controls['mobile_number'].errors?.pattern"
                  class="text-danger"
                >
                  Contact number must be 10 digits long.
                </div>
              </div>
              <div class="form-check mt-2">
                <input
                  class="form-check-input consent-box"
                  type="checkbox"
                  id="defaultCheck1" [formControl]="checkBoxControl"
                  #myCheckbox
                  (change)="onCheckboxChange(myCheckbox.checked)"
                />
                <label class="form-check-label" for="defaultCheck1">
                  Consent to allow TATA Motors to contact you
                </label>
              </div>
            </div>
            <div class="col-12 mt-3">
              <button
                class="btn col-6 btn-primary btn-grad-primary btn-brand"
                data-bs-toggle="modal"
                data-bs-target="#showOtp"
                (click)="sentOtp()"
                [disabled]="userLoginForm.invalid" 
                [ngClass]="{'disabled': !checkBoxcheked}"
              >
                GET CODE
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>



<div
  class="modal fade"
  id="showOtp"
  tabindex="-1"
  aria-labelledby="showOtpLabel"
  aria-hidden="true" 
  [hidden]="!(isshowOtp || isshowSignUp)"
>
  <div class="modal-dialog modal-dialog-centered">
  <div class="modal-content modaldiv" >
      <div class="close-button" style="border-bottom: none !important">
        <button
          type="button"
          id="closeBtn2"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body text-secondary"
        style="height: 100% !important; margin-top: 0px; padding-top: 0px"
      >
      <section *ngIf="isshowOtp">
        <app-otp (loadParent)="showLogin()"  (loadSignup)="showSignup()"></app-otp>
      </section>
      <section *ngIf="isshowSignUp">
        <app-signup (loadParent)="showLogin()" (loadOtpParent)="showOtp()"></app-signup>
      </section>
      </div>
    </div>
    
  </div>
</div>
